// ./src/contexts/TagsContext/tagColors.ts

import { getRandomHexColor } from "@/utils/colorHelpers";
import { DEFAULT_COLOR_PALETTE } from "@/config/colorPalette";

/**
 * The tag color palette. Aliases the shared DEFAULT_COLOR_PALETTE so tags,
 * groups, and website elements all draw from one curated set.
 */
export const TAG_COLOR_PALETTE = DEFAULT_COLOR_PALETTE;

/**
 * Get a color from the palette by index.
 * Wraps around if index exceeds palette length.
 */
export const getTagColorByIndex = (index: number): string => {
  const safeIndex = Math.abs(index) % TAG_COLOR_PALETTE.length;
  return TAG_COLOR_PALETTE[safeIndex];
};

/**
 * Get the next auto-assigned color based on existing tag count.
 * Uses palette colors first, then generates random colors.
 */
export const getNextTagColor = (existingTagCount: number): string => {
  if (existingTagCount < TAG_COLOR_PALETTE.length) {
    return TAG_COLOR_PALETTE[existingTagCount];
  }
  return getRandomHexColor();
};

/**
 * Check if a color is from the predefined palette.
 */
export const isColorFromPalette = (color: string): boolean => {
  const normalizedColor = color.toUpperCase();
  return TAG_COLOR_PALETTE.some(
    (paletteColor) => paletteColor.toUpperCase() === normalizedColor
  );
};

/**
 * Get the index of a color in the palette, or -1 if not found.
 */
export const getColorPaletteIndex = (color: string): number => {
  const normalizedColor = color.toUpperCase();
  return TAG_COLOR_PALETTE.findIndex(
    (paletteColor) => paletteColor.toUpperCase() === normalizedColor
  );
};
